import { render, staticRenderFns } from "./CamaraEnVivoOperaciones.vue?vue&type=template&id=24fd6d9d&scoped=true&"
import script from "./CamaraEnVivoOperaciones.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivoOperaciones.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivoOperaciones.vue?vue&type=style&index=0&id=24fd6d9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd6d9d",
  null
  
)

export default component.exports